(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aa-selected-5sep"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    const recentKey = 'aa-fashion-recent-v1';
    const whatsappIcon = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a9.8 9.8 0 0 0-8.44 14.78L2.2 21.8l5.14-1.35A9.8 9.8 0 1 0 12 2Zm0 17.8a8 8 0 0 1-4.08-1.11l-.29-.17-3.05.8.81-2.97-.19-.3A8 8 0 1 1 12 19.8Zm4.39-5.99c-.24-.12-1.42-.7-1.64-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1.01-.37-1.93-1.19-.71-.64-1.2-1.42-1.34-1.66-.14-.24-.01-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.19-.47-.39-.41-.54-.42h-.46c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.69 2.58 4.1 3.62.57.25 1.02.39 1.37.5.58.18 1.1.16 1.51.1.46-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28Z"/></svg>';

    const readRecent = () => {
      try {
        const value = JSON.parse(localStorage.getItem(recentKey));
        return Array.isArray(value) ? value : [];
      } catch (_) {
        return [];
      }
    };

    const writeRecent = (items) => {
      try {
        localStorage.setItem(recentKey, JSON.stringify(items));
      } catch (_) {}
    };

    const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    })[character]);

    const normalizeUrl = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin ? url.pathname : '/collections/all';
      } catch (_) {
        return '/collections/all';
      }
    };

    const visiblePrice = (scope) => {
      const price = scope?.querySelector('.price');
      if (!price) return '';
      const selector = price.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale'
        : '.price__regular .price-item--regular';
      return (price.querySelector(selector)?.textContent || '').replace(/\s+/g, ' ').trim();
    };

    const productInfo = () => document.querySelector('.product__info-container, product-info');
    const productTitle = (scope) => (scope?.querySelector('.product__title h1, h1')?.textContent || '').trim();
    const productImage = () => document.querySelector('.product__media img, .product-media-container img')?.currentSrc
      || document.querySelector('.product__media img, .product-media-container img')?.src
      || document.querySelector('meta[property="og:image"]')?.content
      || '';

    function addWhatsAppInquiry(scope) {
      if (!scope || scope.querySelector('.aa5-product-actions')) return;
      const source = document.querySelector('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
      if (!source) return;
      const title = productTitle(scope);
      if (!title) return;

      let base;
      try {
        const url = new URL(source.href);
        base = `${url.origin}${url.pathname}`;
      } catch (_) {
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'aa5-product-actions';
      const link = document.createElement('a');
      link.className = 'aa5-whatsapp-inquiry';
      link.target = '_blank';
      link.rel = 'noopener';
      link.href = `${base}?text=${encodeURIComponent(`Assalam-o-Alaikum, mujhe ${title} ke baray mein details chahiye: ${window.location.href}`)}`;
      link.innerHTML = `${whatsappIcon}<span>Ask about this article on WhatsApp</span>`;
      wrapper.appendChild(link);

      const form = scope.querySelector('product-form, .product-form');
      if (form) form.insertAdjacentElement('afterend', wrapper);
      else scope.appendChild(wrapper);
    }

    function createMobileAtc(scope) {
      if (!scope || document.querySelector('.aa5-mobile-atc')) return;
      const original = scope.querySelector('.product-form__submit, product-form button[name="add"], button[name="add"]');
      const title = productTitle(scope);
      if (!original || !title) return;

      const bar = document.createElement('div');
      bar.className = 'aa5-mobile-atc';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = `<div class="aa5-mobile-atc__meta"><span class="aa5-mobile-atc__title">${escapeHtml(title)}</span><span class="aa5-mobile-atc__price">${escapeHtml(visiblePrice(scope))}</span></div><button type="button" class="button" ${original.disabled ? 'disabled' : ''}>${escapeHtml(window.variantStrings?.addToCart || 'Add to cart')}</button>`;
      document.body.appendChild(bar);
      document.body.classList.add('aa5-has-mobile-atc');

      const syncFloatingOffsets = () => {
        const height = Math.ceil(bar.getBoundingClientRect().height);
        if (height > 0) document.documentElement.style.setProperty('--aa5-mobile-atc-height', `${height}px`);
      };

      requestAnimationFrame(syncFloatingOffsets);
      window.addEventListener('resize', syncFloatingOffsets, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(syncFloatingOffsets).observe(bar);

      const stickyButton = bar.querySelector('button');
      stickyButton.addEventListener('click', () => {
        const current = scope.querySelector('.product-form__submit, product-form button[name="add"], button[name="add"]');
        if (current && !current.disabled) current.click();
      });

      const sync = () => {
        const current = scope.querySelector('.product-form__submit, product-form button[name="add"], button[name="add"]');
        bar.querySelector('.aa5-mobile-atc__title').textContent = productTitle(scope);
        bar.querySelector('.aa5-mobile-atc__price').textContent = visiblePrice(scope);
        stickyButton.disabled = Boolean(current?.disabled);
        stickyButton.textContent = current?.querySelector('span')?.textContent?.trim()
          || window.variantStrings?.addToCart
          || 'Add to cart';
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const visible = !entries[0].isIntersecting;
          bar.classList.toggle('is-visible', visible);
          bar.setAttribute('aria-hidden', String(!visible));
          document.body.classList.toggle('aa5-atc-visible', visible);
          if (visible) requestAnimationFrame(syncFloatingOffsets);
        }, { threshold: 0.1 });
        observer.observe(original);
      }

      const mutation = new MutationObserver(sync);
      mutation.observe(scope, { childList: true, subtree: true, characterData: true, attributes: true });
      sync();
    }

    function storeAndRenderRecent(scope) {
      if (!scope) return;
      const title = productTitle(scope);
      if (!title) return;
      const current = {
        url: normalizeUrl(window.location.href),
        title,
        image: productImage(),
        price: visiblePrice(scope)
      };
      const previous = readRecent().filter((item) => normalizeUrl(item.url) !== current.url);
      writeRecent([current, ...previous].slice(0, 8));
      renderRecent(current.url);
    }

    function renderRecent(currentUrl) {
      if (document.querySelector('.aa5-recently-viewed')) return;
      const items = readRecent()
        .filter((item) => normalizeUrl(item.url) !== currentUrl)
        .slice(0, 4);
      if (!items.length) return;

      const section = document.createElement('section');
      section.className = 'aa5-recently-viewed';
      section.setAttribute('aria-labelledby', 'aa5-recent-heading');
      section.innerHTML = `<div class="page-width"><div class="aa5-recently-viewed__head"><h2 id="aa5-recent-heading">Recently Viewed</h2></div><div class="aa5-recently-viewed__grid">${items.map((item) => `<a class="aa5-recent-card" href="${normalizeUrl(item.url)}">${item.image ? `<div class="aa5-recent-card__media"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy" decoding="async"></div>` : ''}<span class="aa5-recent-card__title">${escapeHtml(item.title)}</span><span class="aa5-recent-card__price">${escapeHtml(item.price)}</span></a>`).join('')}</div></div>`;
      const footer = document.querySelector('footer');
      if (footer?.parentNode) footer.parentNode.insertBefore(section, footer);
      else document.querySelector('main')?.appendChild(section);
    }

    function createBackToTop() {
      if (document.querySelector('.aa5-back-top')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'aa5-back-top';
      button.setAttribute('aria-label', 'Back to top');
      button.innerHTML = '<svg class="aa5-back-top__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="m7 14 5-5 5 5M7 19l5-5 5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      document.body.appendChild(button);

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      button.addEventListener('click', () => window.scrollTo({
        top: 0,
        behavior: reducedMotion ? 'auto' : 'smooth'
      }));

      let ticking = false;
      const update = () => {
        const pageHeight = Math.max(
          document.documentElement.scrollHeight,
          document.body.scrollHeight
        );
        const maxScroll = Math.max(pageHeight - window.innerHeight, 1);
        const progress = Math.min(100, Math.max(0, (window.scrollY / maxScroll) * 100));
        const visibilityThreshold = Math.min(
          500,
          Math.max(120, maxScroll * 0.1),
          maxScroll * 0.35
        );
        button.style.setProperty('--aa5-scroll-progress', `${progress.toFixed(2)}%`);
        button.classList.toggle('is-past-half', progress >= 52);
        button.classList.toggle(
          'is-visible',
          maxScroll > 32 && window.scrollY > visibilityThreshold
        );
        ticking = false;
      };
      const requestUpdate = () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      window.addEventListener('load', requestUpdate, { once: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(requestUpdate).observe(document.documentElement);
      }
      update();
    }

    function enhanceProduct() {
      const scope = productInfo();
      if (!scope) return;
      addWhatsAppInquiry(scope);
      createMobileAtc(scope);
      if (!document.documentElement.dataset.aa5RecentStored) {
        document.documentElement.dataset.aa5RecentStored = 'true';
        storeAndRenderRecent(scope);
      }
    }

    function init() {
      enhanceProduct();
      createBackToTop();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();

    document.addEventListener('shopify:section:load', init);
    let timer;
    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(init, 120);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
